import React from 'react';
import PropTypes from 'prop-types';
import { VideoCardGroupContainer, Title, ExtraLink } from './styles';
import VideoCard from './components/VideoCard';
import Slider, { SliderItem } from './components/Slider';
import { ICategoria } from '../../repositories/categorias';

type TParamsCarousel = {
  ignoreFirstVideo?: boolean;
  category: ICategoria;
};

function Carousel({ ignoreFirstVideo, category }: TParamsCarousel) {
  const categoryTitle = category.titulo;
  const categoryColor = category.cor;
  const categoryExtraLink = category.link_extra;
  const { videos } = category;
  return (
    <VideoCardGroupContainer>
      {categoryTitle && (
        <>
          <Title style={{ backgroundColor: categoryColor || 'red' }}>{categoryTitle}</Title>
          {categoryExtraLink && (
            <ExtraLink href={categoryExtraLink.url} target="_blank">
              {categoryExtraLink.text}
            </ExtraLink>
          )}
        </>
      )}
      <Slider color={categoryColor}>
        {videos &&
          videos.map((video, index) => {
            if (ignoreFirstVideo && index === 0) {
              return null;
            }

            return (
              <SliderItem key={video.titulo}>
                <VideoCard videoTitle={video.titulo} videoURL={video.url} categoryColor={categoryColor} />
              </SliderItem>
            );
          })}
      </Slider>
    </VideoCardGroupContainer>
  );
}
Carousel.defaultProps = {
  ignoreFirstVideo: false,
};
Carousel.propTypes = {
  ignoreFirstVideo: PropTypes.bool,
  category: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    link: PropTypes.string,
    cor: PropTypes.string.isRequired,
    link_extra: PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
    videos: PropTypes.arrayOf(
      PropTypes.shape({
        titulo: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default Carousel;
